import { render, staticRenderFns } from "./ModalUpdateAccount.vue?vue&type=template&id=26f8fc20&"
import script from "./ModalUpdateAccount.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports